// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__KSMuw","backButton":"Header_backButton__3TTgj","backImage":"Header_backImage__2LWEi","headerText":"Header_headerText__1Xjda"};